import React, { useEffect, useState } from "react";
import Modal from "../../Modal/Modal";
import "../../../Styles/PhoneKycPopup.css";

function PhoneKycPopup({ isOpen, onClose, email = "" }) {
  const [phone, setPhone] = useState("");
  const [notify, setNotify] = useState(true);
  const [error, setError] = useState("");

  // Reset local state whenever popup opens
  useEffect(() => {
    if (isOpen) {
      setPhone("");
      setNotify(true);
      setError("");
    }
  }, [isOpen]);

  function validatePhone(val) {
    // simple 10-digit number check; adjust to your locale rules as needed
    const digits = val.replace(/\D/g, "");
    return digits.length === 10;
  }

  function handleSave(event) {
    event.preventDefault();

    if (!phone) {
      setError("Please enter phone number.");
      return;
    }

    if (!validatePhone(phone)) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }

    setError("");
    alert("Phone saved. Proceeding to KYC (dummy).");
    onClose();
  }

  function handleSkip(event) {
    event.preventDefault();

    // Confirm the skip (optional)
    const ok = window.confirm(
      "Continue without phone number? Some features may be limited.",
    );

    if (!ok) return;

    onClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="680px"
      ariaLabel="Complete your profile"
    >
      <div className="phone-kyc-shell modal-shell">
        <div className="modal-header">
          <p className="modal-kicker">Complete your profile (1/2)</p>
          <h2 className="modal-title">Enter Phone Number</h2>
          <p className="modal-subtitle">
            Get notified about the latest updates on exclusive deals and promotions.
          </p>
        </div>

        <form className="phone-kyc-form" onSubmit={handleSave} noValidate>
          <div className="phone-kyc-field">
            <label className="phone-kyc-label" htmlFor="phone-input">
              Phone Number
            </label>
            <input
              id="phone-input"
              className={`phone-kyc-input ${error ? "phone-kyc-input--error" : ""}`}
              placeholder="e.g. 83934 xxxxx"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              inputMode="tel"
              aria-invalid={error ? "true" : "false"}
            />
            {error ? <div className="phone-kyc-error">{error}</div> : null}
          </div>

          <div className="phone-kyc-actions">
            <button
              type="button"
              className="modal-button modal-button--secondary"
              onClick={handleSkip}
            >
              Continue without Phone Number
            </button>

            <button type="submit" className="modal-button modal-button--primary">
              Save &amp; Proceed to KYC
            </button>
          </div>

          <p className="phone-kyc-note">
            KYC is mandatory to buy products from Elumia Med Store due to
            regulatory requirements.
          </p>

          <label className="phone-kyc-notify">
            <input
              type="checkbox"
              checked={notify}
              onChange={(e) => setNotify(e.target.checked)}
            />
            <span>Notify me on exclusive updates and special offers</span>
          </label>
        </form>
      </div>
    </Modal>
  );
}

export default PhoneKycPopup;
